import { ELanguage } from '@web_opxp/features';
import {
  EDomain,
  EExerciseCategory,
  IChallenge,
  IDay0Banner,
  IMacOsWarningConfig,
  IWelcomeLp,
  IWelcomeMessageConfig,
  TBlogPreviewConfig,
} from './types';

export const BUILD_ID_FALLBACK = 'local-build';

export const TRAINING_DOMAINS = [EDomain.Speed, EDomain.Reasoning, EDomain.Attention, EDomain.Memory];

export const TRAINING_ID = 1;

export const ASSESSMENT_SESSION_ID = 0;

export const ASSESSMENT_DOMAIN_ID = EDomain.Assessment;

export const SKELETON_CLASSNAME = 'bp5-skeleton';
// this value will never be shown and is used to put some content to not let html tags collapse
export const SKELETON_DUMMYTEXT = 'Loading...';

export const CFQ_DOMAINS = [EDomain.Forgetfulness, EDomain.Distractibility, EDomain.FalseTriggering];

export const NORMALIZED_MAX_SCORE = 10000;

export const MOOD_ID = 20001;
export const MOOD_TRACKER_LIMIT = 20;

// constants storing user stats properties for different stats used by the project
export const GAMEPLAY_SOUND = '4-4-100';
export const GAMEPLAY_BACKGROUND = '4-4-101';
export const GAMEPLAY_FULLSCREEN = '4-4-102';
export const PRIVACY_HIGHSCORE = '9-3-2';
export const DOMAIN_STAT = '9-5-x';
export const WORKOUT_PREFERENCE_STAT = '9-4-x';
export const WORKOUT_PROGRESS_MIGRATION = '9-1-9';
export const CYCLE_INTENSITY = '9-6-0';
export const LED_CONSENT_STAT = '9-7-0';
export const SELF_ASSESSMENT_STAT_ID = '4-12-0';
export const TRAINING_REMINDER = '9-6-1';
export const TRAINING_LED = '9-7-0';
export const NEWS_LETTER_STAT_ID = '4-8-0';
export const PROGRESS_RESET_EVENT_COUNT = '7-0-1';
export const LAST_PROGRESS_RESET = '7-0-0';

// stat definition parts for category mapping for exercises
export const CATEGORY_STAT_TYPE = 0;
export const CATEGORY_COMPONENT_ID = 6;
export const EXERCISE_CATEGORY_STAT = `${CATEGORY_STAT_TYPE}-x-${CATEGORY_COMPONENT_ID}`;
export const DEFAULT_CATEGORY_ID = EExerciseCategory.Medium;

export const CATEGORY_CHANGE_STAT = '0-x-8';

// Firebase defaults
export const DEFAULT_BANNER_CAROUSEL = { variant: 'Variant_Video', enabled: true, timeout: 3050, welcomeHrs: 336 };
export const DEFAULT_DAY0_BANNER: IDay0Banner = {
  variant: 'fallback',
  banner_content: false,
};
export const DEFAULT_WELCOME_LP: IWelcomeLp = {
  variant: 'fallback',
  enabled: false,
};
export const DEFAULT_CHALLENGE: IChallenge = {
  variant: 'fallback',
  activate: false,
};
export const DEFAULT_BLOG_PREVIEW: TBlogPreviewConfig = {
  variant: 'fallback',
  preview: false,
};
export const DEFAULT_WELCOME_MESSAGE: IWelcomeMessageConfig = { variant: '0', welcome_message: false };
export const DEFAULT_MACOS_WARNING: IMacOsWarningConfig = { enabled: true, versions: '15.1,15.4,15.5' };
export const DEFAULT_EXTRA_MODES = false;
export const DEFAULT_CAROUSEL_TIMEOUT_MS = 15000;

export const TRAINING_AVAILABLE_LANGUAGES = [ELanguage.German, ELanguage.English, ELanguage.French, ELanguage.Russian];

/**
 * Colourblindness incompatible exercises:
 * Color Craze - 23,
 * Flash Glance - 18,
 * Form Fever - 2,
 * Quantum Leap - 25,
 * Rotator - 5,
 * Solitaria - 6,
 * Speed of Light - 26
 * IQube - 37
 */
export const ColourblindnessCategoryGroupIds = [23, 18, 2, 25, 5, 6, 26, 37];

/**
 * Dyscalculia incompatible exercises:
 * Chain Reaction - 7,
 * Formula - 12,
 * Logiladder - 15,
 * Math Blitz - 9,
 * Mathrobatics - 16,
 * Reflector - 3,
 * Cashier - 39
 */
export const DyscalculiaCategoryGroupIds = [7, 12, 15, 9, 16, 3, 39];
